<script setup>
import { usePageHead } from '@composables/use-page-head'
import { computed, onMounted, ref } from 'vue'
import { useFavoritesStore } from '@state/stores/favorites'
import Layout from '@layouts/main-layout'
import ShowGridBlock from '@components/show/show-grid-block'
import LibraryHeader from '@components/library/library-header'
import LibrarySearchResults from '@components/library/library-search-results'
import LibrarySectionTabs from '@components/library/library-section-tabs'

const favoritesStore = useFavoritesStore()
const searchQuery = ref('')
const followedShows = computed(() => favoritesStore.followedShows)
const showsLoaded = computed(() => favoritesStore.isLoaded('shows'))

onMounted(() => {
    favoritesStore.fetchType('shows').catch(error => {
        // leave `loaded` untouched — the spinner (not a false empty state) is the FR21 failure mode
        console.error('Failed to refresh followed shows', error)
    })
})

usePageHead({ title: 'Your Shows' })
</script>

<template>
    <Layout>
        <BaseContent>
            <BaseSection padded>
                <LibraryHeader
                    title="Your Shows"
                    :count="showsLoaded ? followedShows.length : null"
                    count-label="shows"
                    :search-query="searchQuery"
                    @update:search-query="searchQuery = $event"
                />
                <LibrarySearchResults
                    v-if="searchQuery.trim()"
                    :query="searchQuery"
                />
                <template v-else>
                    <LibrarySectionTabs />
                    <BaseSpinner v-if="!followedShows.length && !showsLoaded" />
                    <ShowGridBlock
                        v-else-if="followedShows.length"
                        :shows="followedShows"
                    />
                    <BaseEmptyList
                        v-else
                        :error="{
                            title: 'You are not following any shows.',
                            paragraph: 'Following shows helps us recommend similar shows.',
                        }"
                    />
                </template>
            </BaseSection>
        </BaseContent>
    </Layout>
</template>
